import { CurrencyEnum } from '../../lib/types/enums/common/currency.enum'
import { AffectedStaffSalaryFilter } from '../../lib/types/models/affectedStaff/affected-staff'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type AffectedStaffSalaryTotals = {
  totals: { currency: CurrencyEnum; total: number }[]
}

export function getAffectedStaffTotalSalariesWithPas(
  filter?: AffectedStaffSalaryFilter,
  search?: string,
  pasEntry?: boolean
) {
  return restApiClient
    .url(
      encodeNestedObject(API.affectedStaffs.getAffectedStaffsSalaries.url, {
        filter,
        search,
        pasEntry,
        totalSalaryWithPas: true
      })
    )
    .get<AffectedStaffSalaryTotals>()
}

export function getAffectedStaffTotalSalariesWithoutPas(
  filter?: AffectedStaffSalaryFilter,
  search?: string,
  pasEntry?: boolean
) {
  return restApiClient
    .url(
      encodeNestedObject(API.affectedStaffs.getAffectedStaffsSalaries.url, {
        filter,
        search,
        pasEntry,
        totalSalaryWithoutPas: true
      })
    )
    .get<AffectedStaffSalaryTotals>()
}
